export default { sha: 'a2b0e20293c5365b06ad103ed7e7ff46c4f5ac5b', buildNumber: 'undefined' }
